import React from 'react';
import { useAuth0 } from 'neon-auth0';
import { Route } from 'react-router-dom';
import { useUser, TrialState } from '../providers/UserProvider';
import { MessageView, TextBlock, Link } from 'neon-design-system';
import { useLogger } from '../providers/logger/Logger';
import { LogLevel, LogAction } from '../providers/logger/logger-types';
import { createStyles, makeStyles } from '@material-ui/core';
import { config } from '../../config';

const useStyles = makeStyles(theme => createStyles({
	errorMessage: {
		marginTop: `${theme.spacing(15)}px`
	},
	link: {
		fontSize: 'inherit'
	}
}));


const AuthenticatedRoute = ({ permittedRoles, component: Component, ...rest }: any): JSX.Element => {
	const { isAuthenticated } = useAuth0();
	const { trialState, hasScope } = useUser();
	const { printLog } = useLogger();
	const classes = useStyles();

	const hasPermittedRole = permittedRoles.some(hasScope);

	if (isAuthenticated === false || !hasPermittedRole) {
		printLog(LogLevel.WARN, LogAction.Authentication, 'Invalid Route', { route: rest.location });
		return (
			<div className={classes.errorMessage}>
				<MessageView styleName="error" size="medium" title="Access Denied">
					You don't have sufficient permissions to access this area of Neon Insights
				</MessageView></div>);
	}

	if (trialState === TrialState.TrialExpired) {
		printLog(LogLevel.INFO, LogAction.Authentication, 'Trial expired', { route: rest.location });
		return (
			<div className={classes.errorMessage}>
				<MessageView
					styleName="primary"
					size="large"
					title="Your trial has now ended"
					primaryAction={{
						label: 'Return to the Neon Dashboard',
						onClick: () => { window.location.href = config.landingPageUrl }
					}}>
					<TextBlock
						styleName="body"
						xs="small"
						md="medium"
						xl="large"
						color="grey"
						shade={400}>To continue your access to Neon Insights, please contact <Link className={classes.link} ignoreRouter to="mailto:neonsupport@marex.com">neonsupport@marex.com</Link></TextBlock>
				</MessageView></div>);

	}

	return (
		<Route {...rest} render={(props): JSX.Element =>
			<Component {...props} customParams={rest.customProps} />
		} />);
};

export default AuthenticatedRoute;
